import type React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { UpdateSunriseCard } from 'src/app/pages/petitionDetails/shared/components';
import type { PetitionUpdate } from 'src/app/pages/petitionDetails/shared/types';

import { Milestone } from './components/Milestone';
import { VictoryUpdate } from './components/Victory';

type Props = Readonly<{
	update: PetitionUpdate;
	newUpdate?: boolean;
}>;

type UpdateProps = Readonly<{
	update: PetitionUpdate;
	newUpdate?: boolean;
}>;

const UpdateInner = (({ ref, update, newUpdate }) => {
	const { translate, translatePlural, localizeNumber } = useI18n();

	switch (update.type) {
		case 'creation':
			return (
				<Milestone
					ref={ref}
					description={translate('fe.components.updates_feed.created_this_petition', {
						petition_creator: update.displayName,
					})}
					createdAt={update.createdAt}
				/>
			);
		case 'milestone':
			return (
				<Milestone
					ref={ref}
					description={translatePlural('fe.components.updates_feed.signature_milestone_title', update.signatureCount, {
						num: localizeNumber(update.signatureCount),
					})}
					createdAt={update.createdAt}
				/>
			);
		case 'victory':
			return (
				<VictoryUpdate ref={ref} newUpdate={newUpdate} createdAt={update.createdAt} description={update.description} />
			);
		default:
			return <UpdateSunriseCard ref={ref} newUpdate={newUpdate} update={update} />;
	}
}) as React.FC<
	Props & {
		// FIXME this should be typed
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		ref?: React.RefObject<any>;
	}
>;

export const Update = (({ ref, update, newUpdate = false }) => {
	return (
		<div className="mt-4 mb-4 flex flex-row justify-stretch">
			<div className="flex-1">
				<UpdateInner update={update} newUpdate={newUpdate} ref={ref} />
			</div>
		</div>
	);
}) as React.FC<
	UpdateProps & {
		ref?: React.RefObject<unknown>;
	}
>;
